import { ICamera, IClient, IProject } from '@api/models';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface BimServicedListProps {
    isLoading: boolean;
    cameras: ICamera[];
}

const BimServicedList = ({ isLoading, cameras }: BimServicedListProps) => {
    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={cameras}
            columns={[
                { header: 'Camera Name' },
                { header: 'Client' },
                { header: 'Project' },
                // { header: 'Status' },
                { header: 'Created On' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/projects/${
                                (row.project as IProject)._id
                            }/cameras/${row._id}/edit-camera`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.client as IClient).name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${(row.client as IClient)._id}/projects/${
                                (row.project as IProject)._id
                            }/project-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {(row.project as IProject).name}
                        </Link>
                    </Table.Cell>

                    {/* Uncomment this if you want to show camera status as a chip
          <Table.Cell>
            <Chip
              label={row.status}
              color={
                row.status === CameraStatusEnum.ACTIVE
                  ? 'success'
                  : row.status === CameraStatusEnum.INACTIVE
                  ? 'warning'
                  : 'default'
              }
              variant="outlined"
            />
          </Table.Cell> */}

                    <Table.Cell>{moment(row.createdAt).format('DD MMM YYYY, h:mm A')}</Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default BimServicedList;
